import { AttendancePolicyV2Allowance } from '@airreading/common/data';
import { formatAttendancePolicyV2OverviewLines } from '@/lib/attendance-policy-v2-display';

interface AttendancePolicyV2OverviewProps {
  policy: AttendancePolicyV2Allowance;
  'data-testid'?: string;
}

export function AttendancePolicyV2Overview({ policy, 'data-testid': dataTestId }: AttendancePolicyV2OverviewProps) {
  const { totalLine, shortNoticeLine } = formatAttendancePolicyV2OverviewLines(policy);

  return (
    <div className="flex flex-col gap-1 text-sm" data-testid={dataTestId}>
      <div>{totalLine}</div>
      <div>{shortNoticeLine}</div>
    </div>
  );
}
